import Button from '@picsart/button/Button';
import { ButtonSkinTertiary } from '@picsart/button/skins';
import { ReactNode, useState, Children, useEffect, useCallback } from 'react';

import useStyles from './styles';

type LoadMoreProps = {
  children: ReactNode;
  loaded: number;
  text?: string;
};

const LoadMore = ({ children, loaded, text = 'Load More' }: LoadMoreProps) => {
  const styles = useStyles();
  const [loadedCount, setLoadedCount] = useState(loaded);

  const childrenCount = Children.count(children);

  const handleLoadMore = useCallback(() => {
    setLoadedCount((prev) => prev + loaded);
  }, [loaded]);

  useEffect(() => {
    setLoadedCount(loaded);
  }, [loaded]);

  return (
    <>
      <>{Children.toArray(children).slice(0, loadedCount)}</>

      {childrenCount > loadedCount && (
        <Button className={styles.button} skin={ButtonSkinTertiary} onClick={handleLoadMore}>
          {text}
        </Button>
      )}
    </>
  );
};

export default LoadMore;
